'use client';

import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import styled from 'styled-components';

import type { SheetBackdropProps } from '../types';

const isClickable = (props: any) => !!props.onClick || !!props.onTap;

const SheetBackdrop = forwardRef<any, SheetBackdropProps>(({ style = {}, ...rest }, ref) => {
  const Comp = isClickable(rest) ? motion.button : Backdrop;
  const pointerEvents = isClickable(rest) ? 'auto' : 'none';

  return (
    <Comp
      onClick={() => console.log('click')}
      {...rest}
      ref={ref}
      className="react-modal-sheet-backdrop"
      style={{ pointerEvents }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    />
  );
});

const Backdrop = styled(motion.div)`
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.5);
  backdrop-filter: blur(5px);
  touch-action: none;
  pointer-events: none;
`;

export default SheetBackdrop;
